import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { io } from 'socket.io-client';
export class Page {
    size: number = 0;
    totalElements: number = 0;
    totalPages: number = 0;
    pageNumber: number = 0;
}

@Component({
  selector: 'app-inquiry-data',
  templateUrl: './inquiry-data.component.html',
  styleUrls: ['./inquiry-data.component.css']
})
export class InquiryDataComponent implements OnInit {
  @ViewChild('myTable') table: any;
  @ViewChild('idTemplate', { static: true }) idTemplate!: TemplateRef<any>;
  @ViewChild('actTemplate', { static: true }) actTemplate!: TemplateRef<any>;
  @ViewChild('modelTemplate', { static: true }) modelTemplate!: TemplateRef<any>;
  bsConfig: Partial<BsDatepickerConfig>;
  columns: any[]=[];
  allColumns:any[]=[];
  rows: any[] = [];
  expanded: any = {};
  timeout: any;
  formName:any ='';
  totalElements: number;
  pageNumber: number;
  btnLabel:any;
  selectedUser: any;
  followUpList: any[]=[];

  ColumnMode = ColumnMode;
  modalRef: BsModalRef;
  followupNote:any;
  remiderDate:any;
  currId:any;
  socket: any;
  daterang: Date[];
  fromDate:any=0;
  today: Date=new Date();
  toDate:any=0;
  page: Page = {
    pageNumber: 0,
    size: 20,
    totalElements: 0,
    totalPages: 0
  };
  constructor(private auth: AuthService, private activatedRoute: ActivatedRoute, private cdr: ChangeDetectorRef, private modalService: BsModalService, private toastr: ToastrService) {
    this.pageNumber = 0;
  }
  
  ngOnInit() { 
    this.activatedRoute.params.subscribe(params => {
      this.formName = params['name'];
      if (this.formName) {
        this.fetch(0, true);
      }
    });

    this.socket = io(this.auth.geturl()); // backend URL

    this.socket.on('new-lead', (data:any) => {
      // console.log(data);
      if(this.formName == data.type_of_form)
        this.fetch(0, false);
      // this.rows.unshift(data); // add new lead at the top
    });
    this.bsConfig = Object.assign({}, {adaptivePosition: true, dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-black' });
  }

  fetch(page: number, newColumn:any) {
      this.page.pageNumber = page;
      this.auth.getTableData(this.formName,this.page, this.fromDate, this.toDate).subscribe((res:any) => {
          this.page = res.pageData
          this.rows = res.data
          let tempCol:any;
          if(newColumn)
          {
            if (res.data.length > 0) {
              this.columns = Object.keys(res.data[0]).map(key => {
                  if(key == '_id')
                    return { prop: key, name: 'Sr. No.', width: 70, cellTemplate: this.idTemplate };
                  else
                    return { prop: key, name: this.capitalize(key.replace('_',' ')) };
              });
              this.columns = this.columns.filter(col => col.prop !== 'status');
              this.columns = this.columns.filter(col => col.prop !== 'inquiry_no');
              this.columns = this.columns.filter(col => col.prop !== 'followUp');
              this.columns = this.columns.filter(col => col.prop !== 'reminder');
              this.columns = this.columns.filter(col => col.prop !== 'created_at');
              this.columns = this.columns.filter(col => col.prop !== 'message');
              this.columns.splice(1, 0, { prop: 'action', name: 'Action', cellTemplate: this.actTemplate });
              // this.columns = tempCol.filter((c:any) => c.prop !== '_id');
              this.allColumns = Object.assign([],this.columns);
            }
          }
          
          // this.columns.push({prop:'index',name:'Index'});
          // this.columns.push({prop:'action',name:'Action'});
          // console.log(this.columns)
          this.cdr.detectChanges();
      });
  }
  capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  toggle(col:any) {
      const isChecked = this.isChecked(col);

      if (isChecked) {
          this.columns = this.columns.filter(c => {
              return c.name !== col.name;
          });
      } else {
          this.columns = [...this.columns, col];
      }
  }

  dateSelect(event:any){
    console.log(event[0].valueOf())
    console.log(event[1].toDateString())
    if(event[0])
      this.fromDate = event[0].valueOf();
    if(event[1])
      this.toDate = event[1].valueOf();
    
    this.fetch(0, false);
  }
  reset(){
    this.fromDate = 0;
    this.toDate = 0;
    this.fetch(0, false);
  }
  isChecked(col:any) {
      return (
          this.columns.find(c => {
              return c.name === col.name;
          }) !== undefined
      );
  }
  updateStatus(id:any, type:any){
    let data={
      'status': type,
      'id': id
    };
    this.auth.updateTableStatus(this.formName,data).subscribe((res:any)=>{
      // console.log(res);
      this.toastr.success(res.message);
      this.fetch(0, false);
    },(err:any)=>{
      console.log(err);
      this.toastr.error(err.message);
    })
  }
  getOrderedKeyValues(obj: any): { key: string; value: any }[] {
    const primaryKeys = ['name', 'first_name', 'email', 'contact_no'];
    const lastKey = 'created_at';

    const keys = Object.keys(obj);
    const ordered: { key: string; value: any }[] = [];

    // Add name or First Name
    if (keys.includes('name')) {
      ordered.push({ key: 'name', value: obj['name'] });
    } else if (keys.includes('first_name')) {
      ordered.push({ key: 'first_name', value: obj['first_name'] });
    }

    // Add email and contact_no
    ['email', 'contact_no'].forEach(k => {
      if (keys.includes(k) && !ordered.some(item => item.key === k)) {
        ordered.push({ key: k, value: obj[k] });
      }
    });

    // Add middle keys (excluding ones already added and created_at)
    keys.forEach(k => {
      if (
        !['name', 'first_name', 'email', 'contact_no', lastKey].includes(k) &&
        !ordered.some(item => item.key === k)
      ) {
        ordered.push({ key: k, value: obj[k] });
      }
    });

    // Add created_at at last
    if (keys.includes(lastKey)) {
      ordered.push({ key: lastKey, value: obj[lastKey] });
    }

    return ordered;
  }
  saveNote(){
    console.log(this.followupNote)
    console.log(this.remiderDate)
    console.log(this.followupNote != '' || this.remiderDate != '')
    if((this.followupNote != '' || this.remiderDate != '') && this.followupNote != undefined || this.remiderDate != undefined)
    {
      let data={
        'id': this.currId,
        'fowlloup': this.followupNote,
        'remider': this.remiderDate
      }
      this.auth.updateTableNote(this.formName, data).subscribe((res:any)=>{
        // console.log(res);
        this.toastr.success(res.message);
        this.followupNote ='';
        this.remiderDate = null;
        this.fetch(this.page.pageNumber, false);
        this.modalRef.hide()
      },(err:any)=>{
        console.log(err);
        this.toastr.error(err.message);
      })
    }
  }
  showMore(id:any,row:any){
    this.currId = row._id;
    if(row.reminder)
      this.remiderDate = new Date(row.reminder)
    if(row.followUp)
      this.followUpList = row.followUp?row.followUp.reverse():row.followUp;
    this.selectedUser = this.getOrderedKeyValues(row);
    console.log(this.followUpList)
    this.modalRef = this.modalService.show(this.modelTemplate,Object.assign({}, { class: 'detailInquiry' }));
  }
  getRowIndex(rowIndex: number): number {
    return this.page.totalElements - (this.page.pageNumber * this.page.size + rowIndex );
  }

  toggleExpandRow(row: any) {
    this.currId = row._id;
    if(row.reminder)
      this.remiderDate = new Date(row.reminder)
    if(row.followUp)
      this.followUpList = row.followUp?row.followUp.reverse():row.followUp;
    this.selectedUser = this.getOrderedKeyValues(row);
    console.log('Toggled Expand Row!', row);
    this.table.rowDetail!.toggleExpandRow(row);
  }

  onDetailToggle(event: any) {
    console.log('Detail Toggled', event);
  }
  exportData(){    
    this.auth.exportdata(this.formName).subscribe((res:any)=>{
      console.log(res)
      if(res.success)
             window.open(res.fileUrl, '_blank');
    },(err:any)=>{
        console.log(err);
        this.toastr.error(err.message);
    })
  }
}
